import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { CountriesKey, Address, StatesKey } from '../@types/address.type';
import { getCountries, getStatesByCountryId } from '../api/address';

export const useGetCountries = (): UseQueryResult<Address[]> => {
  return useQuery({
    queryKey: [CountriesKey],
    queryFn: () => getCountries(),
    staleTime: 5 * 60 * 60 * 1000
  });
};

export const useGetStatesByCountryId = (countryId: number): UseQueryResult<Address[]> => {
  return useQuery({
    queryKey: [StatesKey, countryId],
    queryFn: () => getStatesByCountryId(countryId),
    enabled: false,
    staleTime: 5 * 60 * 60 * 1000
  });
};
